import { Navigate, useLocation } from 'react-router-dom';

const AUTH_KEY = 'omya_logged_in';

export function isLoggedIn() {
  return typeof window !== 'undefined' && sessionStorage.getItem(AUTH_KEY) === '1';
}

export function setLoggedIn(value) {
  if (typeof window !== 'undefined') {
    if (value) {
      sessionStorage.setItem(AUTH_KEY, '1');
    } else {
      sessionStorage.removeItem(AUTH_KEY);
    }
  }
}

export function ProtectedRoute({ children }) {
  const location = useLocation();

  if (!isLoggedIn()) {
    return <Navigate to="/" state={{ from: location }} replace />;
  }

  return children;
}
